// extracted by mini-css-extract-plugin
export default {"cards":"projectCard_cards__2tQh3","image":"projectCard_image__IlUQ9"};